import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "@root/app.service";
import { CheckableList } from "@root/common/extends/checkable-list";
import { ModalService } from "@root/router/index/modal.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalService } from "ng-zorro-antd/modal";

@Component({
  selector: "v4-common-order-list",
  templateUrl: "./order.component.html",
  styleUrls: ["./order.component.scss"],
})
export class V4CommonOrderListComponent implements OnInit {
  @Input() listOfOrder = [];
  @Input() total = 0;
  @Input() page = 1;
  @Input() pageSize = 20;
  @Input() checkable = false;
  @Input() checkableList: CheckableList;
  @Input() operateType: "simple" | "detail" = "simple";
  @Output() onPageChange = new EventEmitter();
  @Output() onComplete = new EventEmitter();
  @Output() onClickReservation = new EventEmitter();

  get isInternational() {
    return this.app.app.international;
  }

  constructor(
    private t: TranslateService,
    private modal: NzModalService,
    private globalModalService: ModalService,
    private msg: NzMessageService,
    private http: HttpClient,
    private app: AppService
  ) {}

  ngOnInit() {}

  onClickCheckButton(reservation) {
    const { code, out_status } = reservation;
    let title, content;
    if (out_status === "wait_stay") {
      title = this.t.t("warning.order.confirm_check_in");
      content = this.t.t("warning.order.confirm_tenant_in");
    } else if (out_status === "staying") {
      title = this.t.t("warning.order.confirm_check_out");
      content = this.t.t("warning.order.confirm_tenant_out");
    }

    this.modal.confirm({
      nzTitle: title,
      nzContent: content,
      nzOnOk: () => {
        this.requestUpdateCheckStatus(code, out_status === "wait_stay" ? "staying_checkin" : "staying_checkout");
      },
    });
  }

  onClickAcceptButton(reservation) {
    this.requestApproveReservation(reservation.code).subscribe((res: any) => {
      if (res.error_code === 0) {
        this.onComplete.emit();
        this.msg.success(this.t.t("success.order.accept_order"));

        // this.globalModalService.displayTujiaAutoReceiptModal(code);
      } else {
        this.msg.warning(this.t.t("warning.order.accept_order_failed"));
      }
    });
  }

  onClickDeclineButton(reservation) {
    this.requestDeclineReservation(reservation.code).subscribe((res: any) => {
      if (res.error_code === 0) {
        this.onComplete.emit();
        this.msg.success(this.t.t("success.order.refuse_order"));
      } else {
        this.msg.warning(this.t.t("warning.order.refuse_order_failed"));
      }
    });
  }

  onHoverRow(order, hovering) {
    order.reservations.forEach((r) => {
      r.hovering = hovering;
    });
  }

  onClickRateButton(reservation) {
    const modal = this.globalModalService.displayRateModal({ code: reservation.code });
    modal.afterClose.subscribe((res) => this.onComplete.emit());
  }

  private requestUpdateCheckStatus(code, status) {
    const params = {
      reservation_code: code,
      to_status: status,
    };
    this.http.get("/api/reservation/handle_staying_status", { params }).subscribe((res: any) => {
      if (res.error_code === 0) {
        this.onComplete.emit();
      }
    });
  }

  private requestApproveReservation(code) {
    const params = {
      reservation_code: code,
    };
    return this.http.post("/api/reservation/approve", params);
  }

  private requestDeclineReservation(code) {
    const params = {
      reservation_code: code,
    };
    return this.http.post("/api/reservation/decline", params);
  }

  // onClickAcceptButton(reservation) {
  //   this.requestApproveReservation(reservation.code).subscribe((res) => {
  //     if (res.error_code === 0) {
  //       this.onComplete.emit();
  //       this.msg.success(this.t.t("success.order.accept_order"));

  //       // this.globalModalService.displayTujiaAutoReceiptModal(code);
  //     } else {
  //       this.msg.warning(this.t.t("warning.order.accept_order_failed"));
  //     }
  //   });
  // }
}
